import * as S from './styles'

interface IErrorTextProps {
  message?: string
}

const ErrorText = ({ message }: IErrorTextProps) => {
  return <S.HelperText>{message}</S.HelperText>
}

export { ErrorText }
export type { IErrorTextProps }
